import Card from "../Components/General/Card/Card";
import { CardSuit, CardValue, ICard } from "../Models/CardModels";

const suits = Object.values(CardSuit).filter((v): v is CardSuit => typeof v === "number");
const values = Object.values(CardValue).filter((v): v is CardValue => typeof v === "number");

export const cardList: ICard[] = suits.flatMap(suit =>
    values.map(value => ({ deckId: 0, suit, value, cardId: `preload-${suit}-${value}` }))
);

export function Preloader() {
    return (
        <div aria-hidden className="fixed w-0 h-0 overflow-hidden pointer-events-none">
            <Card card={{ cardId: "preload-back" }} invisible />
            {cardList.map(card => (
                <Card key={card.cardId} card={card} invisible />
            ))}
        </div>
    );
}
